import {
	AnyApiFactory,
	configApiRef,
	createApiFactory,
	discoveryApiRef,
	fetchApiRef,
	identityApiRef,
	analyticsApiRef,
	storageApiRef,
} from '@backstage/core-plugin-api';
import {
	ScmAuth,
	scmAuthApiRef,
	ScmIntegrationsApi,
	scmIntegrationsApiRef,
} from '@backstage/integration-react';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import { MoonpigTechRadarApi } from './apis/techRadar';
import { GoogleAnalytics4 } from '@backstage-community/plugin-analytics-module-ga4';
import { githubActionsHealthApiRef } from '@internal/plugin-github-actions-extensions';
import { GitHubActionsHealthClient } from '@internal/plugin-github-actions-extensions/src/api/GitHubActionsHealthClient';
import { MultipleAnalyticsApi } from '@backstage/core-app-api';
import { BackstageInsightsApi } from '@spotify/backstage-plugin-analytics-module-insights';

export const apis: AnyApiFactory[] = [
	createApiFactory({
		api: githubActionsHealthApiRef,
		deps: { configApi: configApiRef, scmAuthApi: scmAuthApiRef },
		factory: ({ configApi, scmAuthApi }) =>
			new GitHubActionsHealthClient(configApi, scmAuthApi),
	}),
	createApiFactory({
		api: scmIntegrationsApiRef,
		deps: { configApi: configApiRef },
		factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
	}),
	createApiFactory({
		api: techRadarApiRef,
		deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
		factory: ({ discoveryApi, identityApi }) =>
			new MoonpigTechRadarApi({
				discovery: discoveryApi,
				identity: identityApi,
			}),
	}),
	// GA4 Analytics API Implementation.
	createApiFactory({
		api: analyticsApiRef,
		deps: {
			configApi: configApiRef,
			discoveryApi: discoveryApiRef,
			fetchApi: fetchApiRef,
			identityApi: identityApiRef,
			storageApi: storageApiRef,
		},
		factory: ({ configApi, discoveryApi, fetchApi, identityApi, storageApi }) =>
			MultipleAnalyticsApi.fromApis([
				GoogleAnalytics4.fromConfig(configApi, {
					identityApi,
					userIdTransform: async (userEntityRef: string): Promise<string> => {
						return userEntityRef;
					},
				}),
				BackstageInsightsApi.fromConfig(configApi, {
					discoveryApi,
					fetchApi,
					identityApi,
					storageApi,
				}),
			]),
	}),
	ScmAuth.createDefaultApiFactory(),
];
